import type { TOC } from '@ember/component/template-only';

import TeamsViewComponent from 'webapp/components/teams/view/index';

import type Team from 'webapp/models-custom/team';

interface Args {
	model: Team;
}

const TeamsViewRouteTemplate: TOC<Args> = <template>
	<TeamsViewComponent @model={{@model}} />
</template>;

export default TeamsViewRouteTemplate;
